import { CoreIcon } from '../core-icon';
import homeScreenSVG from '../../assets/icons/home-screen.svg';
import type { IconProps } from '../core-icon';

export const HomeScreenIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={homeScreenSVG} {...props} />;
};
